export class DrugInteractionModel{
  divisitserial = 0 ;
  patientcode = '';
  didescription = '' ;
  dinotes = '' ;
  diimage;
  compcode = '1' ;
  userid = 'sa' ;
  modifieddate = '2022-01-01' ;
}
